// extracted by mini-css-extract-plugin
export default {"parent-wrapper":"styles_parent-wrapper__wLxsK","builder-wrapper":"styles_builder-wrapper__-nct1","content":"styles_content__9Rdfd"};